const endpoint = property => `/api/${ property }/events/days`;

export default ['api', function(api) {
  return {
    save: day => {
      let url = day.id ? `${ endpoint(api.property()) }/${ day.id }` : endpoint(api.property());

      return api.upload(url, day).then(response => response.data);
    },
    delete: id => api.delete(`${ endpoint(api.property()) }/${ id }`),
    findAll: (page = undefined, perpage = undefined, deleted = undefined) => {
      return api.get(endpoint(api.property())+(!isNaN(page) ? '?page='+(page)+ (page > -1 ? '&perpage='+(perpage || '20') : '') : '')+(deleted ? '&deleted=true' : '')).
        then(response => response.data);
    },
    findById: id => {
      return api.get(`${ endpoint(api.property()) }/${ id }`)
        .then(response => response.data);
    },
    toggleActive: id => {
      return api.get(`${ endpoint(api.property()) }/status/${ id }`)
        .then(response => response.data);
    },
    toggleVisible: id => {
      return api.get(`${ endpoint(api.property()) }/visible/${ id }`)
        .then(response => response.data);
    },
    search: (type, text, page = null) => {
      return api.get(`${endpoint(api.property()) }?type=${type}&text=${text}`+(page ? '&page='+page : '')).then(response => response.data);
    },
    reconstruct: order => {
      return api.post(`${ endpoint(api.property()) }/reconstruct`, order)
      .then(response => response.data);
    },
    updatePriority: spaday => {
      return api.post(`${ endpoint(api.property() )}/${ spaday.id}/priority?priority=${spaday.priority}`)
    }
  };
}];



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/days/services/day.service.js